import { Attributes, DateUtils, Misc, NeoModel, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class BankAccountBalanceLookupCriteria extends ValueObject {

    public bankAccountId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.add(new Date(), {days: -7});

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = new Date();


    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public reset() {
        this.startDate = DateUtils.add(new Date(), {days: -7});
        this.endDate = new Date();
        this.bankAccountId = 0;
    }

    public toString(): string {
        return "Bank Account Balance Lookup Criteria";
    }
}